import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { TitleSVG } from '@common_components/svg/title.svg';

const TitleIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <TitleSVG/>
    </div>
  );
};

export { TitleIcon };
